import { Spinner } from 'flowbite-react';
import React from 'react';
import PreInterviewComponent from 'src/components/interviews/PreInterviewComponent';
import { useGetAllSkills } from 'src/hooks/skill.hooks';
import { SkillType } from 'types';

const PreScreeningDetails = () => {
	const { data: skillsData, isLoading } = useGetAllSkills({
		type: SkillType.SKILL,
	});

	if (isLoading) return <Spinner />;
	const allSkillsOptions = skillsData?.skills?.map(skill => ({ label: skill.name, value: skill._id }));
	return <PreInterviewComponent allSkillsOptions={allSkillsOptions} />;
};

export default PreScreeningDetails;
